export default {
	sec_10: {
		title: {
			one: 'Free transfer ',
			two: 'fee',
		},
		desc: {
			one: 'No fees for transfers between JP WORLD Pay!',
		},
		btn: {
			one: 'Sign up',
			two: 'Download App',
		},
	},
	sec_11: {
		one: {
			title: {
				one: 'When depositing to an external wallet, ',
				two: 'only the network fee is charged.',
			},
			desc: {
				one: 'When making a deposit, JP WORLD Pay does not request payment of fees.',
			},
		},
		two: {
			title: {
				one: 'Movement within our platform is free.',
			},
			desc: {
				one: 'Fees apply only for external withdrawals. Fees are free when purchasing using JP WORLD Pay.',
			},
		},
	},
};
